import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { C as Collection } from './collection-vo45ysQ4.js';
import './uniq-BDEfcc0N.js';
import './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

/**
 * Get the section id from an id
 * @param {string} id - The id to get the section id from
 * @returns {string} - The section id
 */
function getSectionId({ id = '' }) {
  return id.includes('__') ? id.split('__').pop() : id.replace('shopify-section-', '');
}

class ListingGrid extends HTMLElement {
  #unsubscriber;
  #closestSection = this.closest('[id^="shopify-section-"]');
  #sectionId = getSectionId(this.#closestSection);

  connectedCallback() {
    Collection.sections.push(this.#sectionId);

    // Subscribe to filters updated event
    this.#unsubscriber = PubSub.subscribe('collection:filter', ({ status, data }) => {
      status === 'success' && this.#replaceListingGrid(data.sections);
    });
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * Replace listing grid
   * @param {object[]} sections - Sections to replace
   * @param {string} sections.section - Section to replace
   * @param {Document} sections.html - Html to replace the current listing grid
   */
  #replaceListingGrid(sections) {
    const section = sections.find(({ section }) => section === this.#sectionId);
    if (!section) return;

    const parsedListingGrid = section.html.querySelector('listing-grid');

    // Clone the element to avoid modifying the shared HTML object
    const clonedListingGrid = parsedListingGrid.cloneNode(true);

    this.innerHTML = clonedListingGrid.innerHTML;
    this.#rebindFilterDrawer();
  }

  /**
   * Re-bind filter drawer toggles replaced during section rendering
   */
  #rebindFilterDrawer() {
    const drawer = document.getElementById('filter-drawer');
    if (!drawer) return;

    this.querySelectorAll('[aria-controls="filter-drawer"]:not([data-filter-bound])').forEach(
      (controller) => {
        controller.setAttribute('data-filter-bound', 'true');

        controller.addEventListener('click', (event) => {
          event.preventDefault();
          if (typeof drawer.toggle === 'function') {
            drawer.toggle();
          } else {
            drawer.ariaHidden === 'true' ? drawer.open() : drawer.close();
          }
        });
      }
    );
  }
}

customElements.define('listing-grid', ListingGrid);
